import React from 'react';
import { useTranslation } from 'react-i18next';

import './PointsDisclaimer.css';

/**
 * Friskrivning om att plattformens poäng saknar ekonomiskt värde.
 *
 * Visas överst på de två sidor där något byter ägare — Belöningar och
 * Marknaden. Poängen är fiktiva, går inte att köpa för pengar och går inte
 * att växla tillbaka; utan det sagt rakt ut kan sidorna läsas som en butik
 * med riktig valuta, vilket de inte är.
 *
 * Det spelar roll på fler sätt än ett. Flera spelutgivares riktlinjer för
 * fan-innehåll tillåter uttryckligen icke-kommersiell användning men
 * undantar sidor med spel om pengar — och plattformen har både en
 * parimutuell marknad och ett veckolotteri. Att skillnaden syns på sidan är
 * en del av att den faktiskt gäller.
 *
 * Texten är kort med flit. En friskrivning ingen orkar läsa gör ingen nytta.
 *
 * @returns {JSX.Element}
 */
export default function PointsDisclaimer() {
  const { t } = useTranslation();

  return (
    <p className="points-disclaimer" role="note">
      {t('common.pointsDisclaimer')}
    </p>
  );
}
